import { useQuery } from '@apollo/client';
import { startOfMonth, subMonths } from 'date-fns';
import { useState } from 'react';

import { Endpoint } from '@/apollo/apolloClient';
import { GET_DASHBOARD_ANALYTICS } from '@/apollo/schemas/dashboard/dashboard';
import { Loader } from '@/components/common/Loader';
import NoResults from '@/components/common/noResult/NoResultFound';
import DashboardCard from '@/components/dashboard/DashboardCard';
import {
  DashboardDataFilter,
  DateRangeInput,
  Period,
  SortBy,
} from '@/components/dashboard/DashboardDataFilter';
import { OrderStatusChart } from '@/components/dashboard/OrderCharts';
import { RevenueTrendChart } from '@/components/dashboard/RevenueTrendChart';
import { TopProducts } from '@/components/dashboard/TopProductCharts';
import { useAuth } from '@/context/CoginitoAuthProvider';
import { AnalyticsDataResponse } from '@/types/dashboardData';

const Dashboard = () => {
  const { session } = useAuth();
  const jwtToken = session
    ? session?.getIdToken().getJwtToken()
    : localStorage.getItem('idToken');
  const [filters, setFilters] = useState<{
    period: Period;
    sortBy: SortBy;
    dateRange: DateRangeInput;
  }>({
    period: Period.DAILY,
    sortBy: SortBy.QUANTITY,
    dateRange: {
      startDate: getLastMonthStart(),
      endDate: new Date().toISOString(),
    },
  });

  const { loading, data } = useQuery<AnalyticsDataResponse>(
    GET_DASHBOARD_ANALYTICS,
    {
      variables: {
        dateRage: filters.dateRange,
        period: filters.period,
        sortBy: filters.sortBy,
      },
      context: {
        version: Endpoint.admin,
        headers: {
          identity: jwtToken,
        },
      },
    },
  );
  function getLastMonthStart() {
    const now = new Date();
    return startOfMonth(subMonths(now, 6)).toISOString();
  }

  const onFilterChange = (filters: {
    period: Period;
    sortBy: SortBy;
    dateRange: DateRangeInput;
  }) => {
    setFilters(filters);
  };

  if (loading || !data?.ProductAnalytics.data) {
    return (
      <main className="flex flex-col p-6 gap-y-7 overflow-auto h-full">
        <DashboardDataFilter onChange={onFilterChange} />
        <Loader show={loading} />
        {!data?.ProductAnalytics.data && !loading && <NoResults />}
      </main>
    );
  }

  if (!data?.ProductAnalytics.data) {
    return <></>;
  }
  return (
    <main className="flex flex-col p-6 gap-y-7 overflow-auto h-full">
      <DashboardDataFilter onChange={onFilterChange} />

      {data?.ProductAnalytics.data && (
        <DashboardCard data={data?.ProductAnalytics.data} />
      )}
      {/* Charts Grid */}
      <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-7">
        {/* Revenue Trend - Larger */}
        <div className="lg:col-span-4">
          {<RevenueTrendChart data={data?.ProductAnalytics.data} />}
        </div>

        {/* Sidebar with smaller charts */}
        <div className="lg:col-span-3 space-y-6">
          <OrderStatusChart data={data?.ProductAnalytics.data} />
        </div>
      </div>
      <TopProducts data={data?.ProductAnalytics.data} />
      {/* <div className="grid grid-cols-12 gap-7 h-fit">
        <div className="col-span-12 md:col-span-8 bg-slate-50">
          <UserStatesChart />
        </div>

        <div className="col-span-12 md:col-span-4 bg-slate-50">
          <DashboardWebsite DashboardWebsiteData={DashboardWebsiteData} />
        </div>

        <div className="col-span-12 bg-slate-50 md:col-span-6">
          <DeviceTrafficBarChart />
        </div>

        <div className="col-span-12 md:col-span-6 bg-slate-50">
          <TrafficChartPieChart />
        </div>
      </div> */}
    </main>
  );
};

export default Dashboard;
